module.exports = __webpack_public_path__ + "static/media/mortgage-rent.56f0c969.svg";